<template>
    <div class="challenge-userboard">
        <div
            class="challenge-userboard__user1"
            :class="userStatusClass1">
            <img :src="userImageLink1" class="challenge-userboard__user-img">
            <span class="challenge-userboard__username">{{ username1 }}</span>
            <span class="challenge-userboard__user-status">
                <span class="challenge-userboard__user-status-icon"></span>
                <span class="challenge-userboard__user-status-text">{{ userStatusText1 }}</span>
            </span>
        </div>

        <div
            class="challenge-userboard__user2"
            :class="userStatusClass2">
            <img :src="userImageLink2" class="challenge-userboard__user-img">
            <span class="challenge-userboard__username">{{ username2 }}</span>
            <span class="challenge-userboard__user-status">
                <span class="challenge-userboard__user-status-icon"></span>
                <span class="challenge-userboard__user-status-text">{{ userStatusText2 }}</span>
            </span>
        </div>

        <div class="challenge-userboard__scoreboard">
            <span class="challenge-userboard__scoreboard-icon"></span>
            <div class="challenge-userboard__stat">
                <span class="challenge-userboard__stat-1">{{ statCorrect1 }}</span>
                <span class="challenge-userboard__stat-label">DOĞRU</span>
                <span class="challenge-userboard__stat-2">{{ statCorrect2 }}</span>
            </div>
            <div class="challenge-userboard__stat">
                <span class="challenge-userboard__stat-1">{{ statIncorrect1 }}</span>
                <span class="challenge-userboard__stat-label">YANLIŞ</span>
                <span class="challenge-userboard__stat-2">{{ statIncorrect2 }}</span>
            </div>
        </div>

        <span class="challenge-userboard__art-bg--left"></span>
        <span class="challenge-userboard__art-bg--right"></span>
        <span
            class="challenge-userboard__art-status-pattern-1"
            :class="userStatusClass1"></span>
        <span
            class="challenge-userboard__art-status-pattern-2"
            :class="userStatusClass2"></span>

        <button
            class="btn-close-view"
            @click="this.$store.state.envDev ? leaveChallenge() : leaveChallengeApi()">
            <span class="btn-close-view__icon"></span>
        </button>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        data(){
            return {
                allowRequest: true,
            };
        },

        computed: {
            username1(){
                if(this.$store.state.challengeSession.user1.username === this.$store.state.userSession.username){
                    return 'sen';
                }
                return this.$store.state.challengeSession.user1.username;
            },

            username2(){
                if(this.$store.state.challengeSession.user2.username === this.$store.state.userSession.username){
                    return 'sen';
                }
                return this.$store.state.challengeSession.user2.username;
            },

            userImageLink1(){
                // return this.$store.state.api.img + this.$store.state.challengeSession.user1.id + '.jpg';
                return this.$store.state.api.getImage + this.$store.state.challengeSession.user1.id;
            },

            userImageLink2(){
                // return this.$store.state.api.img + this.$store.state.challengeSession.user2.id + '.jpg';
                return this.$store.state.api.getImage + this.$store.state.challengeSession.user2.id;

            },

            userStatusText1(){
                return this.$t(`challenge.status.${this.$store.state.challengeSession.user1.status.toLowerCase()}`);
            },

            userStatusText2(){
                return this.$t(`challenge.status.${this.$store.state.challengeSession.user2.status.toLowerCase()}`);
            },

            statCorrect1(){
                if(this.$store.state.challengeSession.userType === 1){
                    return this.$store.state.challengeStats.correct;
                }
                return '?';
            },

            statCorrect2(){
                if(this.$store.state.challengeSession.userType === 2){
                    return this.$store.state.challengeStats.correct;
                }
                return '?';
            },

            statIncorrect1(){
                if(this.$store.state.challengeSession.userType === 1){
                    return this.$store.state.challengeStats.incorrect;
                }
                return '?';
            },

            statIncorrect2(){
                if(this.$store.state.challengeSession.userType === 2){
                    return this.$store.state.challengeStats.incorrect;
                }
                return '?';
            },

            userStatusClass1(){
                return `challenge-userboard-user--${this.$store.state.challengeSession.user1.status.toLowerCase()}`;
            },

            userStatusClass2(){
                return `challenge-userboard-user--${this.$store.state.challengeSession.user2.status.toLowerCase()}`;
            },
        },

        methods: {
            leaveChallenge(){},
            leaveChallengeApi(){
                if(this.allowRequest === false){
                    return false;
                }
                this.allowRequest = false;

                this.$foneturkConfirmation('Çıkmak istediğine emin misin?', 'ÇIKIŞ ONAYI')
                .then(swalAlertResult => {
                    if(!swalAlertResult.isConfirmed){
                        this.allowRequest = true;
                        return false;
                    }
                    this.$emit('enableLoading');
                    fetch(this.$store.state.api.challengeLeave, {
                        method: 'POST',
                        credentials: 'include',
                    })
                    .then(async response => {
                        if(response.status !== 200){
                            throw await response.json();
                        }
                        return response.json();
                    })
                    .then(leavingData => {
                        if(leavingData.result !== true){
                            this.$foneturkError({
                                text: this.$t(`error.default`),
                                didClose: () => {
                                    // this.$router.push('/');
                                }
                            });
                            return true;
                        }
                        this.$router.push('/challenge/list');
                    })
                    .catch(err => {
                        if(err.code === 'CHALLENGE_LEAVE_MODEL/LEAVE::INV_USER_SESSION'){
                            this.$foneturkError({
                                text: this.$t(`error.api.challengeLeave.${err.code}`),
                                didClose: () => {
                                    // this.$router.push('/login');
                                }
                            });
                            return true;
                        }
                        this.$foneturkError({
                            text: this.$t(`error.default`),
                        });
                        this.allowRequest = true;
                        this.$emit('disableLoading');
                    });
                });
            }
        },
    };
</script>

<style scoped src="@/css/components/challenge-userboard.css"></style>